    <div class="inline-tooltip"  [ngClass]="{ 'bottom-spacing': withBottomSpacing }">
        <img class="inline-tooltip__img" src="assets/img/icons/mobile-tooltip.png" alt="info" />
        <div class="inline-tooltip--text" [innerHTML]="content"> 
        </div>
    </div>
